<template>
  <div v-if="!src" :class="className">
    <div v-if="add" class="ico-plus"></div>
    <slot></slot>
  </div>
  <img v-else :src="src" :class="className" />
</template>

<script>
export default {
  name: "IconText",
  props: {
    src: {
      type: String,
    },
    add: {
      type: Boolean,
      default: false,
    },
    // type: [ default, required, monitoring, warning, recovery ]
    type: {
      type: String,
      default: "",
    },
    // size: [ xs, sm, lg ]
    size: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      className: "",
      types: {
        required: "required",
        monitoring: "monitoring",
        warning: "warning",
        recovery: "recovery",
        stop: "stop",
      },
      sizes: {
        xs: "ico-xs",
        sm: "ico-s",
        lg: "ico-lg",
      },
    };
  },
  created() {
    if (this.src || this.add) {
      this.className = "ico-base ";

      if (this.add) {
        this.className += "ico-add";
      }

      this.className += this.sizes.hasOwnProperty(this.size)
        ? this.sizes[this.size]
        : "";
    } else {
      this.className = "ico-txt ";
      this.className += this.types.hasOwnProperty(this.type)
        ? this.types[this.type]
        : "";
    }
  },
};
</script>
